import { useState } from 'react';
import { Table, Button, Tag, Space, Popconfirm, App, type TableColumnsType } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useMediaModels, useDeleteMediaModel } from '@/hooks/useMedia';
import type { MediaModel } from '@/types/media';
import { MediaModelFormModal } from './MediaModelFormModal';

const TASK_COLOR: Record<string, string> = { t2i: 'blue', i2i: 'geekblue', t2v: 'purple', i2v: 'magenta' };

export function MediaModelsSection() {
  const { message } = App.useApp();
  const q = useMediaModels();
  const del = useDeleteMediaModel();
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState<MediaModel | null>(null);

  const columns: TableColumnsType<MediaModel> = [
    { title: 'Model', dataIndex: 'model' },
    { title: 'Provider', dataIndex: 'provider' },
    { title: 'Task', dataIndex: 'taskType', render: (t) => <Tag color={TASK_COLOR[t] ?? 'default'}>{t}</Tag> },
    { title: 'API id', dataIndex: 'apiModelId' },
    { title: 'Price', render: (_, r) => `$${r.unitPrice} / ${r.unit.replace('per_', '')}` },
    { title: 'Enabled', dataIndex: 'enabled', render: (e) => <Tag color={e ? 'success' : 'default'}>{e ? 'on' : 'off'}</Tag> },
    { title: 'Default', dataIndex: 'isDefault', render: (d) => (d ? <Tag color="gold">default</Tag> : null) },
    { title: '', width: 90, render: (_, r) => (
      <Space>
        <Button size="small" icon={<EditOutlined />} onClick={() => { setEditing(r); setOpen(true); }} />
        <Popconfirm title={`Delete ${r.model}?`} onConfirm={async () => {
          try { await del.mutateAsync(r.model); message.success('Deleted'); }
          catch (e) { message.error((e as Error).message); }
        }}>
          <Button size="small" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      </Space>
    ) },
  ];

  return (
    <div>
      <Space style={{ marginBottom: 12, justifyContent: 'space-between', width: '100%' }}>
        <b>Media models (image / video generation)</b>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => { setEditing(null); setOpen(true); }}>Add</Button>
      </Space>
      <Table rowKey="model" size="small" loading={q.isLoading} columns={columns} dataSource={q.data ?? []} pagination={false} />
      <MediaModelFormModal open={open} editing={editing} onClose={() => setOpen(false)} />
    </div>
  );
}
